import { API_ROUTES, request } from '../instance';

export type PartnerAPI = {
  id: number;
  name: string;
  uuid: string;
  safeBrowserEnabled: boolean;
  enableSelfService: boolean;
  showDocumentToPartner: boolean;
  active: boolean;
};

export const getAll = () => {
  return request<PartnerAPI[]>({
    url: `${API_ROUTES.partners()}`,
    method: 'GET',
  });
};

export const get = (uuid: string) => {
  return request<PartnerAPI>({
    url: `${API_ROUTES.partner(uuid)}`,
    method: 'GET',
  });
};
